(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('IssueSignificanceDialogController', IssueSignificanceDialogController);

    IssueSignificanceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'IssueSignificance'];

    function IssueSignificanceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, IssueSignificance) {
        var vm = this;

        vm.issueSignificance = entity;
        vm.clear = clear;
        vm.save = save;
        
        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.issueSignificance.id !== null) {
                IssueSignificance.update(vm.issueSignificance, onSaveSuccess, onSaveError);
            } else {
                IssueSignificance.save(vm.issueSignificance, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:issueSignificanceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
